shadow$provide[0] = function(require,module,exports) {
module.exports=(ReactDOMClient);
};